exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/dynamic-tips/tree-list/tree-list.component.css
// module id = ../../../../../src/app/modules/dynamic-tips/tree-list/tree-list.component.css
// module chunks = main